import { render, staticRenderFns } from "./ImprestAccounting.vue?vue&type=template&id=36b6476c&scoped=true"
import script from "./ImprestAccounting.vue?vue&type=script&lang=js"
export * from "./ImprestAccounting.vue?vue&type=script&lang=js"
import style0 from "./ImprestAccounting.vue?vue&type=style&index=0&id=36b6476c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6476c",
  null
  
)

export default component.exports